export enum DraggableMessageType {
  MessageDocument = "message-document",
  MessageImage = "message-image",
  MessageVideo = "message-video",
  MessageText = "message-text",
}

export type DroppableItem = {
  messageId: string;
  type: DraggableMessageType;
  files?: File[];
  renderText?: () => string;
};

export interface UseDroppableProps {
  acceptType?: string | string[];
  acceptSystemFile?: boolean;
  onDrop?: (item: DroppableItem) => void;
  onDropFiles?: (files: File[]) => void;
  shallow?: boolean;
}
